import { render } from "./LinkingAccount.vue?vue&type=template&id=2019220a&scoped=true"
import script from "./LinkingAccount.vue?vue&type=script&lang=js"
export * from "./LinkingAccount.vue?vue&type=script&lang=js"

import "./LinkingAccount.vue?vue&type=style&index=0&id=2019220a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2019220a"]])

export default __exports__